import { FC } from "react";
import { useAppStore } from "@/store";
import { SettingsTabId } from "@/store/pages/SettingsPageStore";
import { observer } from "mobx-react-lite";
import { CalendarIntegrationNotConnectedContentView } from "./calendar-integration-not-connected-content.view";

export const CalendarIntegrationNotConnectedContent: FC = observer(() => {
  const { store } = useAppStore();

  const handleClick = () => {
    store.settingsModal.open(SettingsTabId.CalendarAndMeetingsPage);
  };

  return <CalendarIntegrationNotConnectedContentView onClick={handleClick} />;
});
